module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CGwkNF6YA5qoAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAsUlEQVQ4T6XQwQ2DMAwFUDMHQ/TUUXpBrNFTu3sql3wc/xjqEktfIsZ5CYjIVHyGairP1/sbj/EhnLAMM9D3ohyAPXa/zeWxLq7P0ZkANEwBHQJ2BmKGwDFMnxvQMEAthg285gMr+BvjMKbZMTR0QNdZbAPa1M0IXrS9KHUzl230AzGKfh3iwstoyDB8Yj+TLn+zAayH8PP/BI8hJAn2/4mhJOhvlEFPwBjTXMKuRUvkA1HPrixkfQWVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/smithing-icon.png
// module id = 505
// module chunks = 0